<!-- A small picture of a device for the Devices list: the same render the
     Pager screen uses, at thumbnail size (public/devices/<id>@1x / @2x).
     No live text — at this size it would not be legible. Decorative: the card
     around it names the device. -->
<template>
  <span class="pm-dev-thumb" :class="`pm-dev-thumb--${art.id}`" aria-hidden="true">
    <img
      class="pm-dev-thumb__img"
      :src="art.thumb"
      :srcset="`${art.thumb} 1x, ${art.thumb2x} 2x`"
      alt=""
      loading="lazy"
      decoding="async"
      draggable="false"
    >
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { artFor } from '../pm/device-art.js';
import { deviceById } from '../pm/devices.js';

const props = defineProps({
  deviceId: { type: String, required: true },
});

const art = computed(() => {
  const d = deviceById(props.deviceId);
  return { id: d.id, ...artFor(d.id) };
});
</script>
